import React from 'react';
import { useFormContext } from 'ui-builder';
import { BaseInputLayoutWidgetProps } from '../index';
import ErrorsWrapper from '../input/layout/ErrorsWrapper';
import { cn } from 'shadcn-ui';

function ShadcnBaseInputLayout(props: BaseInputLayoutWidgetProps) {
  const formContext = useFormContext();

  const showRequiredIcon = props.showRequiredIcon !== undefined ? props.showRequiredIcon : true;

  let result;

  if (props.showLabel === undefined || props.showLabel) {
    const Wrapper = props.afterLabelElement ? 'div' : 'label';

    result = (
      <Wrapper className={cn('grid gap-2', props.className)} data-testid={props.testId}>
        {!props.hideLabel && (
          <span className="flex items-center justify-between text-base leading-none font-medium text-gray-600 select-none">
            <span className="flex items-center gap-2">
              {props.label}
              {showRequiredIcon
                && formContext.isFieldRequired
                && formContext.isFieldRequired(props.name)
                && (<span className="text-rose-600">*</span>)}
            </span>
            {props.afterLabelElement}
          </span>
        )}
        {props.children}
        {props.hint && (
          <div className="text-xs text-gray-400">
            {props.hint}
          </div>
        )}
      </Wrapper>
    );
  } else {
    result = props.children;
  }

  if (!props.hideValidationErrors) {
    return (
      <ErrorsWrapper name={props.name} errors={props.errors}>
        {result}
      </ErrorsWrapper>
    );
  } else {
    return result;
  }
}

export default ShadcnBaseInputLayout;
